import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { IraUserRequest, IraUserResponse } from 'services/requests';
import { useQueryParams } from 'hooks/routes';
import { Parameters } from 'constants/queryParameters';
import { QueryKeys } from 'constants/queryKeys';
import { MutationKeys } from 'constants/mutationKeys';
import { Messages } from 'constants/messages';
import { showInfoToast } from 'components/Toast';

export const useEditIraUser = () => {
  const queryClient = useQueryClient();
  const iraUserId = useQueryParams(Parameters.iraUserId);

  const mutate = async (payload: Partial<IraUserRequest>) => {
    const { data } = await api.editIraUser(iraUserId, payload);

    return data;
  };

  const mutationKey = MutationKeys.editIraUser;

  return useMutation<IraUserResponse, AxiosError<ApiError>, Partial<IraUserRequest>>(
    mutationKey,
    mutate,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QueryKeys.iraUser);
        showInfoToast(Messages.saveChanges);
      },
    },
  );
};
